import React from 'react';
import { Box, Grid } from '@lifechurch/react-ion';
import TableHeaderColumn from './TableHeaderColumn';

const TableHeader: React.FC = () => (
  <Grid
    gridTemplateColumns='16px 150px repeat(4,1fr) 80px 80px 15px'
    gridColumnGap='1rem'
    px={5}
    marginBlockEnd={3}
    fontSize={2}
  >
    <Box />
    <TableHeaderColumn />
    <Box />
  </Grid>
);

export default TableHeader;
